// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2487":"20d62627","4727":"ff8e6804"}[chunkId] + ".chunk.css");